// Yes.jsx
import React, { useMemo } from "react";
import "./yes.css";
import hug from "../../../assets/couple.gif";

export const Yes = () => {
  const isInAppBrowser = useMemo(() => {
    const ua = navigator.userAgent || "";
    return /FBAN|FBAV|FB_IAB|Messenger|Instagram/i.test(ua);
  }, []);



  return (
    <div className="yes-page">
      <main className="wrap">
        <section className="card" aria-label="Valentine yes card">
          <h1 className="title">You got no other choice baby 😂💖</h1>

    

          <p className="subtitle">  You make my world softer and brighter.</p>
          <p className="subtitle"> I am trying to be better everyday and will keep you happy forever. </p>

          <p className="line">Now come here baby… your hug is my favorite place. 🫶😘</p>

          <div className="gif" aria-label="Romantic gif">
            <img src={hug} alt="Romantic moment" loading="eager" />
          </div>

          <div className="note">
            <p>
              I love you more than yesterday, less than tomorrow… and always more
              than you think. 🌙✨
            </p>
            <p>You will always get the treat you deserve. 😌💖</p>
            <p>All gifts pending for next Valentine huss 😁😁</p>
            <p className="sig">— I love you Baby❤️</p>
          </div>

          <button className="btn" >
            ❤️😍💕😘😘😘
          </button>

          
        </section>
      </main>
    </div>
  );
};

export default Yes;
